export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-checkbox-7b31e877e67a930248982ddba9c48531.svg";